module.exports = __webpack_public_path__ + "static/assets/988634094b40949793ecb8554a6fc951.svg";